function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useClearRefinements, useSearchBox } from 'react-instantsearch-core';
import { Button as RKSButton } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../config/constants';
const SearchReset = props => {
  const {
    t
  } = useTranslation();
  const {
    refine: clearRefinements
  } = useClearRefinements();
  const {
    clear: clearSearch
  } = useSearchBox();
  const {
    button,
    onClick,
    className,
    buttonText = t(['searchkit.buttons.reset', DEFAULT_TEXT.BUTTONS.RESET]),
    resetRefinements = true,
    resetSearch = true
  } = props;
  const classNames = c('Searchkit__Reset', className);
  const Button = button || RKSButton;
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    className: classNames,
    onClick: () => {
      if (resetRefinements) {
        clearRefinements();
      }
      if (resetSearch) {
        clearSearch();
      }
      if (onClick) {
        onClick();
      }
    }
  }), buttonText);
};
export default SearchReset;